import { getI18n, getCurrencyOptions } from './Amalgam';
import { getCatalogueTheme } from './Theme';

export default {
  t: (key, data) => {
    let text = getI18n()[key];

    if (!data) {
      return text;
    }

    Object.keys(data).forEach((key) => {
      text = text.replace(new RegExp('%{' + key + '}', 'g'), data[key]);
    });

    return text;
  }
};

export const getPriceStyles = () => {
  const currencyOptions = getCurrencyOptions();

  const styles = {};
  if (currencyOptions.direction) {
    styles.direction = currencyOptions.direction;
  }
  styles.color = getCatalogueTheme().priceTextColor || '#2f5ec6';

  return styles;
};
